import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import withAuthentication from './auth/session/withAuthetication';

import Header from './components/Header';

import LandingPage from './views/LandingPage.view';
import Login from './views/Login.view';
import Dashboard from './views/Dashboard.view';
import PasswordResetView from './views/PasswordReset.view';
import PasswordChangeView from './views/PasswordChange.view';
import Admin from './views/Admin.view';

class App extends Component {
    render() {
        return (
            <Router>
                <Header />
                <Route exact path='/' component={LandingPage} />
                <Route path='/login' component={Login} />
                <Route path='/dashboard' component={Dashboard} />
                <Route path='/password-reset' component={PasswordResetView} />
                <Route path='/password-change' component={PasswordChangeView} />
                <Route path='/admin' component={Admin} />
            </Router>
        );
    }
}

export default withAuthentication(App);
